import { render, staticRenderFns } from "./SalesOrdersComponent.vue?vue&type=template&id=afc667d6&scoped=true&"
import script from "./SalesOrdersComponent.vue?vue&type=script&lang=js&"
export * from "./SalesOrdersComponent.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrdersComponent.vue?vue&type=style&index=0&id=afc667d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc667d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VDataTable,VIcon,VProgressLinear})
